import React, {useEffect, useState} from 'react';
import {TableCell, TableRow} from "../Commons/TBTable.react";
import {dateFormatter} from "../../Utilities/utilities";
import CurrencyFormatter from "../Commons/CurrencyFormatter.react";

const TransactionRow = ({enterprise=false, transaction, handleClick, key, index, gains=0, price=0}) => {
  const [fee, setFee] = useState();
  const [usdVolume, setUSD] = useState();

  useEffect(() => {
    //TODO: set fee and usd depending on transaction type
    // switch(transaction.type) {
    //   type 'BUY':
    //
    // }
  }, [transaction])

  if (enterprise) {
    let transactionFee = transaction.fee_asset_code == 'BTC' ? {type: 'ASSET', symbol: ''}: {type: 'FIAT', symbol: '$'}
    return (
      <TableRow onClick={() => handleClick(transaction)} key={index} index={index}>
        <TableCell width={'50%'}>{dateFormatter(transaction.datetime)}</TableCell>
        {/*//TODO: Make source dynamic*/}
        <TableCell width={'50%'}>{transaction.source ? 'Institutional' : 'Retail'}</TableCell>
        <TableCell width={'50%'}>{transaction.source ? transaction.source : 'User'}</TableCell>
        <TableCell width={'50%'}>{transaction.type}</TableCell>
        <TableCell>{transaction.user_id ? transaction.user_id : '-'}</TableCell>
        <TableCell>{transaction.id}</TableCell>
        <TableCell textAlign={'right'} fontFamily={'monospace'} width={'50%'}><CurrencyFormatter type={'FIAT'} quantity={price} symbol={'$'} /></TableCell>
      </TableRow>
    )
  } else {
    return (
      <TableRow onClick={() => handleClick(transaction)} key={key} index={index}>
        <TableCell>{dateFormatter(transaction.datetime)}</TableCell>
        <TableCell>{transaction.type}</TableCell>
        <TableCell><CurrencyFormatter type={'FIAT'} quantity={gains} code={'USD'} symbol={'$'} /></TableCell>
        <TableCell><CurrencyFormatter type={'FIAT'} quantity={price} code={'USD'} symbol={'$'} /></TableCell>
      </TableRow>
    )
  }
}

export default TransactionRow;